'use client';

import { c as _c } from "react/compiler-runtime";
import type { PrV2SummaryResponse } from '@/lib/pr-v2/types';
import { useHotkeys } from 'react-hotkeys-hook';
import { Button } from '@/components/ui/button';
import { KeyboardShortcut } from '@/components/ui/keyboard-shortcut';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { usePrV2PublishAction } from '@/data/v2/pr/use-pr-v2-publish-action';
import { PullRequestState } from '@/lib/github/graphql/types';
type PrV2PublishButtonProps = {
  owner: string;
  repo: string;
  number: string;
  summary: PrV2SummaryResponse['pullRequest'];
};
export function PrV2PublishButton(t0) {
  const $ = _c(23);
  const {
    owner,
    repo,
    number,
    summary
  } = t0;
  const publishMutation = usePrV2PublishAction(owner, repo, number);
  let t1;
  if ($[0] !== summary.state) {
    t1 = summary.state.toLowerCase();
    $[0] = summary.state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = PullRequestState.Closed.toLowerCase();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isClosed = t1 === t2;
  let t3;
  if ($[3] !== publishMutation) {
    t3 = () => {
      if (publishMutation.isPending) {
        return;
      }
      publishMutation.mutate();
    };
    $[3] = publishMutation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handlePublish = t3;
  let t4;
  if ($[5] !== handlePublish || $[6] !== isClosed || $[7] !== summary.draft || $[8] !== summary.merged) {
    t4 = event => {
      event.preventDefault();
      if (summary.draft && !summary.merged && !isClosed) {
        handlePublish();
      }
    };
    $[5] = handlePublish;
    $[6] = isClosed;
    $[7] = summary.draft;
    $[8] = summary.merged;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      enableOnFormTags: false,
      enabled: true
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isClosed || $[12] !== publishMutation.isPending || $[13] !== summary.draft || $[14] !== summary.merged) {
    t6 = [summary.draft, summary.merged, isClosed, publishMutation.isPending];
    $[11] = isClosed;
    $[12] = publishMutation.isPending;
    $[13] = summary.draft;
    $[14] = summary.merged;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  useHotkeys("shift+p", t4, t5, t6);
  if (!summary.draft || summary.merged || isClosed) {
    return null;
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-2">Undraft PR</div>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== handlePublish || $[18] !== publishMutation.isPending) {
    t8 = <TooltipTrigger asChild={true}><Button variant="outline" size="sm" className="relative max-md:h-10 max-md:w-full" onClick={handlePublish} disabled={publishMutation.isPending}>{t7}</Button></TooltipTrigger>;
    $[17] = handlePublish;
    $[18] = publishMutation.isPending;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TooltipContent><div className="flex items-center gap-2">Mark PR ready for review<KeyboardShortcut>⇧P</KeyboardShortcut></div></TooltipContent>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8) {
    t10 = <div className="flex justify-end max-md:flex-1"><TooltipProvider><Tooltip>{t8}{t9}</Tooltip></TooltipProvider></div>;
    $[21] = t8;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}